'use client';
import { Component, createContext, type PropsWithChildren } from 'react';

type ErrorContextProps = {
  outerError?: Error;
};

export const ErrorContext = createContext<ErrorContextProps>({});

export class ErrorBoundary extends Component<PropsWithChildren, ErrorContextProps> {
  state = {};

  static getDerivedStateFromError(outerError: Error): ErrorContextProps {
    return { outerError };
  }

  render() {
    return <ErrorContext.Provider value={this.state}>{this.props.children}</ErrorContext.Provider>;
  }
}
